import { NeuInput } from "@neutron/react";
interface InputProps {
    className?: string,
    disabled?: boolean,
    value?: any,
    onChange?: (e: any) => void,
    onBlur?: (e: any) => void,
    placeholder?: string,
    type?: 'color' | 'email' | 'hidden' | 'number' | 'tel' | 'text' | 'url' | 'date' | 'time',
    autocomplete?: string,
    inputmode?: string,
    enterkeyhint?: "search" | "enter" | "done" | "go" | "next" | "previous" | "send",
    autocorrect?: "on" | "off",
    required?: boolean,
    min?: number,
    max?: number,
    maxlength?: number,
    readonly?: boolean
}

export function Input(props: InputProps) {
    return (
        <NeuInput required={props.required} type={props.type} label={props.placeholder!} min={props.min}
            className={props.className} value={props.value} max={props.max}
            maxlength={props.maxlength} readonly={props.readonly}
            onNeuBlur={(e: any) => props.onBlur?.(e)}
            onNeuChange={(e: any) => props.onChange?.(e)} disabled={props.disabled}/>
    )
}